<button (click)="printLabels()">Print Labels</button>

<div id="print-area">
  <!-- Label template -->
  <div  class="label">
    <h3>Product: Macbook pro</h3>
    <qrcode [qrdata]="qrdata" [width]="100"></qrcode>
    <p>ID: 5464564</p>
  </div>
</div>